module.exports = __webpack_public_path__ + "img/72.94fcb2c4.png";